import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../shared/components/RouteError";
import { RoutePending } from "../../shared/components/RoutePending";

/**
 * @purpose Change my own account settings
 * @primary Settings form
 * @persona all
 */
export const Route = createFileRoute("/app/settings/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
